import { createSelector } from '@ngrx/store';
import { CACHED_REQUEST_STATUS } from '../../classes/cached-request';
import { RefreshRequestQueueState } from '../types/refresh-request-queue.state';
import { selectOfflineFeature } from './pace-offline-feature.selector';

export const selectRefreshRequestQueue = createSelector(selectOfflineFeature, (state) => state.refreshRequestQueue);

export const hasGETErrorOccured = createSelector(selectRefreshRequestQueue, (state: RefreshRequestQueueState) =>
    Object.values(state.refreshRequests).find((request) => request.refreshStatus === CACHED_REQUEST_STATUS.ERROR),
);

export const hasGETErrorOccurredForRequest = createSelector(
    selectRefreshRequestQueue,
    (state: RefreshRequestQueueState, props: { url: string }) =>
        Object.values(state.refreshRequests).find(
            (request) => request.url.includes(props.url) && request.refreshStatus === CACHED_REQUEST_STATUS.ERROR,
        ),
);

export const selectIsRefreshDone = createSelector(
    selectRefreshRequestQueue,
    (state: RefreshRequestQueueState, props: { url: string }) => {
        const matchedRequest = state.refreshRequests[props.url];
        return matchedRequest && matchedRequest.refreshStatus === CACHED_REQUEST_STATUS.COMPLETED;
    },
);

export const selectIsRefreshAllDone = createSelector(selectRefreshRequestQueue, (state) => {
    const pendingRequest = Object.values(state.refreshRequests).find(
        (request) => request.refreshStatus === CACHED_REQUEST_STATUS.PENDING,
    );
    return !pendingRequest;
});

export const getAllRequestToBeRefreshed = createSelector(selectRefreshRequestQueue, (state: RefreshRequestQueueState) =>
    Object.values(state.refreshRequests),
);

export const getSpecificRequestToBeRefreshed = createSelector(
    selectRefreshRequestQueue,
    (state: RefreshRequestQueueState, props: { url: string }) => state.refreshRequests[props.url],
);

export const getRefreshRequestCount = createSelector(
    selectRefreshRequestQueue,
    (state) => Object.keys(state.refreshRequests).length,
);

export const hasLegacyEncryptedData = createSelector(
    selectRefreshRequestQueue,
    (state) => Object.keys(state.refreshRequests).length,
);
